import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';

const PRESENT_COPY = 'Thinking through the request';
const PAST_COPY = 'Thought through the request';

const payloadSchema = z.object({
    text: z.string().max(100_000),
});

export const assistantReasoningDefinitions = {
    assistant_reasoning: defineStandalone('assistant_reasoning', {
        disposition: 'render',
        schema: payloadSchema,
        malformed: {
            kind: 'placeholder',
            customerCopy: PAST_COPY,
        },
        evidence: null,
        group: {
            kind: 'activity',
            boundary: 'consecutive_same_kind',
            phase(_payload, _compoundState, occurrence) {
                return occurrence.phase === 'committed'
                    ? 'completed'
                    : 'active';
            },
            presentSummary() {
                return PRESENT_COPY;
            },
            pastSummary() {
                return PAST_COPY;
            },
        },
        render(_payload, occurrence) {
            return (
                <span>
                    {occurrence.phase === 'committed'
                        ? PAST_COPY
                        : PRESENT_COPY}
                </span>
            );
        },
    }),
} as const;

export const assistantReasoningContractFixtures = {
    valid: {
        type: 'assistant_reasoning',
        text: 'internal-reasoning-sentinel',
    },
    malformed: {
        type: 'assistant_reasoning',
        text: 1,
    },
} as const;
